import { ProductRelatedProductsLine } from 'Components/lines/product-related-products-line/ProductRelatedProductsLine';
export default ProductRelatedProductsLine;
